/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { RegisterState, RegisterTypes } from './types';

const REQUEST_DEFAULT = { loading: false, loaded: false, error: false };

const INITIAL_STATE: RegisterState = {
  draft: null,
  company: null,
  user_exists: false,
  request: {
    fetch_company: { ...REQUEST_DEFAULT },
    check_email: { ...REQUEST_DEFAULT },
  },
};

const reducer: Reducer<RegisterState> = (state = INITIAL_STATE, { type, result, data }) => {
  return produce(state, (draft) => {
    switch (type) {
      case RegisterTypes.SET_DRAFT:
        draft.draft = data;
        break;
      case RegisterTypes.CLEAR_REGISTER:
        draft.draft = null;
        draft.company = null;
        draft.user_exists = false;
        draft.request.fetch_company = { loading: false, loaded: false, error: false };
        break;
      case RegisterTypes.FETCH_COMPANY_REQUEST:
        draft.request.fetch_company.loading = true;
        draft.request.fetch_company.loaded = false;
        draft.request.fetch_company.error = false;
        break;

      case RegisterTypes.FETCH_COMPANY_SUCCESS:
        draft.company = result?.data;
        draft.request.fetch_company.loading = false;
        draft.request.fetch_company.loaded = true;
        draft.request.fetch_company.error = false;
        break;

      case RegisterTypes.FETCH_COMPANY_FAILURE:
        draft.request.fetch_company.loading = false;
        draft.request.fetch_company.loaded = true;
        draft.request.fetch_company.error = true;
        break;

      case RegisterTypes.CHECK_EMAIL_REQUEST:
        draft.request.check_email.loading = true;
        draft.request.check_email.loaded = false;
        draft.request.check_email.error = false;
        break;

      case RegisterTypes.CHECK_EMAIL_SUCCESS:
        draft.user_exists = Boolean(result?.data?.exists);
        draft.request.check_email.loading = false;
        draft.request.check_email.loaded = true;
        draft.request.check_email.error = false;
        break;

      case RegisterTypes.CHECK_EMAIL_FAILURE:
        draft.request.check_email.loading = false;
        draft.request.check_email.loaded = true;
        draft.request.check_email.error = true;
        break;
      default:
    }
  });
};
export default reducer;
